var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRssFeedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84991 6C6.58207 6 6.31595 6.00694 6.0517 6.02064C5.50015 6.04924 5.02985 5.62531 5.00125 5.07377C4.97266 4.52222 5.39659 4.05193 5.94813 4.02333C6.24685 4.00784 6.54751 4 6.84991 4C16.3216 4 23.9999 11.6783 23.9999 21.15C23.9999 21.4524 23.9921 21.7531 23.9766 22.0518C23.948 22.6033 23.4777 23.0273 22.9261 22.9987C22.3746 22.9701 21.9507 22.4998 21.9793 21.9482C21.993 21.684 21.9999 21.4178 21.9999 21.15C21.9999 12.7829 15.217 6 6.84991 6Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16537 16.0692C6.43612 16.0238 6.71486 16 6.99991 16C9.76134 16 11.9999 18.2386 11.9999 21C11.9999 21.285 11.9762 21.5638 11.9307 21.8345C11.8394 22.3792 12.2068 22.8948 12.7515 22.9862C13.2962 23.0776 13.8118 22.7101 13.9032 22.1655C13.9669 21.7858 13.9999 21.3964 13.9999 21C13.9999 17.134 10.8659 14 6.99991 14C6.60354 14 6.21412 14.033 5.83446 14.0967C5.28978 14.1881 4.92232 14.7037 5.0137 15.2484C5.10507 15.7931 5.6207 16.1606 6.16537 16.0692Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 21C8.99989 22.1046 8.10446 23 6.99989 23C5.89532 23 4.99989 22.1046 4.99989 21C4.99989 19.8954 5.89532 19 6.99989 19C8.10446 19 8.99989 19.8954 8.99989 21Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08966 11.0408C6.38923 11.0138 6.69283 11 6.99991 11C12.5228 11 16.9999 15.4772 16.9999 21C16.9999 21.3071 16.9861 21.6107 16.9591 21.9102C16.9095 22.4603 17.3153 22.9464 17.8653 22.996C18.4154 23.0455 18.9015 22.6398 18.951 22.0898C18.9834 21.7306 18.9999 21.3671 18.9999 21C18.9999 14.3726 13.6273 9 6.99991 9C6.63282 9 6.26932 9.01651 5.91016 9.04888C5.36011 9.09845 4.95438 9.58454 5.00395 10.1346C5.05352 10.6846 5.53961 11.0904 6.08966 11.0408Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssFeedOutline);
export default __webpack_public_path__ + "static/media/rss_feed_outline.3eeb483e298b9b357f00c058f3bd39ef.svg";
export { ForwardRef as ReactComponent };